module.exports = __webpack_public_path__ + "static/img/news-20240407.00a774d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news-20240407.png
// module id = fd1b
// module chunks = 0